import { render, staticRenderFns } from "./ReportSettings.vue?vue&type=template&id=4364b168&scoped=true&"
import script from "./ReportSettings.vue?vue&type=script&lang=ts&"
export * from "./ReportSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4364b168",
  null
  
)

export default component.exports